// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__WUNBD","title":"ClientReferral_title__3COjb","itemText":"ClientReferral_itemText__2MyxM"};